export default __webpack_public_path__ + "static/media/github.678001e7.svg";